import { lazy } from 'react';

/** Открывает раздел статистики отправок */
export const MessageSendStatisticsPage = lazy(() => import('./MessageSendStatisticsPage'));
